import { createContext, type FC, type PropsWithChildren, useContext } from 'react';

const RouteLoadingShellContext = createContext(false);

export const RouteLoadingShellProvider: FC<PropsWithChildren> = ({ children }) => (
  <RouteLoadingShellContext.Provider value>{children}</RouteLoadingShellContext.Provider>
);

export const useRouteLoadingShellMounted = (): boolean => useContext(RouteLoadingShellContext);
